import { observable, action } from 'mobx';
import agent from '../api/agent';
import userStore from './userStore';
import commonStore from './commonStore';
import navigatorStore from './navigatorStore';
import {
  validateIfInputHasCharacters,
  validateIfInputHasSpaces,
  validateIfInputHasUpperCaseLetter,
  validateIfInputHasYourMasterpieces,
  validateIfInputIsEmail,
  validateInputLength
} from "../../src/helpers/validationChecks";
class AuthStore {
  @observable inProgress = false;
  @observable errors = undefined;
  @observable loginErr;
  @observable RegisterSuccess;
  @observable onboardingOneIncomplete = false;
  @observable onboardingTwoIncomplete = false;
  @observable onboardingThreeIncomplete = false;
  @observable changePasswordForSecurity = false;
  @observable tokenForPasswordChange = "";
  @observable emailForPasswordChange = "";
  @observable updateComplete = false;


  @observable values = {
    username: '',
    email: '',
    password: '',
    rememberMe: false,
    login_type: 'email',
  };

  @action makeOnboardingOneIncomplete() {
    this.onboardingOneIncomplete = true;
    this.updateComplete = true
  }
  @action makeOnboardingTwoIncomplete() {
    this.onboardingTwoIncomplete = true;
    this.updateComplete = true
  }
  @action makeOnboardingThreeIncomplete() {
    this.onboardingThreeIncomplete = true;
    this.updateComplete = true
  }
  @action makeRegisterSuccess() {
    this.RegisterSuccess = true;
    this.updateComplete = true
  }
  @action resetRegisterSuccess() {
    this.RegisterSuccess = false;
    this.updateComplete = true
  }

  @action setEmail(email) {
    this.values.email = email;
  }

  @action setPassword(password) {
    this.values.password = password;
  }

  @action setRememberMe(rememberMe) {
    this.values.rememberMe = !rememberMe
  }

  @action reset() {
    this.values.username = '';
    this.values.email = '';
    this.values.password = '';
    this.values.rememberMe = false;
    this.values.login_type = 'email';
    this.values.loginDone = false

  }

  @action setInfoForSecurityPWD(email, key) {
    this.emailForPasswordChange = email;
    this.tokenForPasswordChange = key
  }


  @action validateUsername(username, api, data, forSocial) {
    if ((username) && (
      !validateInputLength(username, 6, 30)
      || validateIfInputHasCharacters(username)
      || validateIfInputHasUpperCaseLetter(username)
      || validateIfInputHasYourMasterpieces(username)
    )) {
      if (!data.interests) {
        !forSocial && this.makeRegisterSuccess();
      }
      else if (!data.preferences) {
        !forSocial && this.makeRegisterSuccess()
      }
      else !forSocial && this.makeOnboardingThreeIncomplete()
      return false;
    }
    if (api) {
      var formData = new FormData();

      formData.append("display_name", username)
      // if (!!response.data.user_profile[0].old_display_name && (this.state.curr_display_name != response.data.user_profile[0].old_display_name))
      return userStore.validateDisplayName(formData)
        .then((response) => {
          // console.log(response)
          if (response.error == "True") {
            this.makeOnboardingThreeIncomplete()
            // this.props.navigatorStore.openErrorModal(response.data)
            return false;
          }

        })
        .catch((err => {
          this.makeOnboardingThreeIncomplete()
        }));
    } else {
      return true;
    }
  }
  @action login() {
    this.inProgress = true;
    this.errors = undefined;

    var formData = new FormData();
    formData.append("email", this.values.email)
    formData.append("password", this.values.password)
    return agent.Auth.login(formData)
      .then((response) => {
        // console.log("came in here")
        // console.log("resp = ", response)
        if (!response || response == {}) {
          navigatorStore.openErrorModal("Something went wrong. Please try again.")
          return;
        }
        if (response.message == "Please change your password") {
          //   this.props.navigatorStore.openErrorModal(response.message);
          navigatorStore.openChangePasswordForSecurity();
          this.setInfoForSecurityPWD(response.email, response.key)
          return;
        }
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(this.values.email)) {
          navigatorStore.openErrorModal("not a valid email");
          return;
        }
        if (response.error == "True") {
          navigatorStore.openErrorModal(response.error)
          // userStore.setErr(response)
          this.loginErr = true
          return;
        }
        if (response.error == "False" && response.data.token && response.data.token != "") {
          // console.log(response)
          commonStore.setToken(response.data.token,
            (response.data.user_profile[0].display_name) ? response.data.user_profile[0].display_name : response.data.user_profile[0].old_display_name,
            response.data.user_profile[0].image,
            response.data.user_profile[0].id,
            response.data.user_profile[0].preferred_currency, this.values.email,
            response.data.user_profile[0].full_name);
          userStore.setUser(response.data);
          var url = response.data.user_profile[0].share_url
          localStorage.setItem("username", url.substr(url.lastIndexOf("/") + 1))
          localStorage.setItem("primary_email", response.data.user_profile[0].primary_email)
          localStorage.setItem("country", response.data.user_profile[0].country)
          localStorage.setItem("full_name", response.data.user_profile[0].full_name)
          // if (!response.data.user_profile[0].interests) {
          //   // console.log("interests null")
          //   this.makeOnboardingOneIncomplete()
          // }
          // if (!response.data.user_profile[0].preferences) {
          //   // console.log("preferences null")
          //   this.makeOnboardingTwoIncomplete()
          // }
          if (!response.data.user_profile[0].display_name && !!response.data.user_profile[0].old_display_name) {
            let isValid = this.validateUsername(response.data.user_profile[0].old_display_name, true, response.data.user_profile[0])
            let userProfile = response.data.user_profile[0];
            if (!isValid) {
              if (!userProfile.interests) {
                this.makeRegisterSuccess();
              }
              else if (!userProfile.preferences) {
                this.makeRegisterSuccess()
              }
              else this.makeOnboardingThreeIncomplete()
           
            }
          }
          if (!!response.data.user_profile[0].display_name) {
            let isValid = this.validateUsername(response.data.user_profile[0].display_name, false, response.data.user_profile[0])
            let userProfile = response.data.user_profile[0];
            if (!isValid) {
              if (!userProfile.interests) {
                this.makeRegisterSuccess();
              }
              else if (!userProfile.preferences) {
                this.makeRegisterSuccess()
              }
              else {
                 this.makeOnboardingThreeIncomplete() }
         
            }
          }
          if (!response.data.user_profile[0].full_name ||
            !response.data.user_profile[0].country ||
            (!response.data.user_profile[0].display_name && !response.data.user_profile[0].old_display_name) ||
            !response.data.user_profile[0].primary_email ||
            !response.data.user_profile[0].preferred_currency
          ) {
            let userProfile = response.data.user_profile[0];
            if (!userProfile.interests) {
              this.makeRegisterSuccess();
            }
            else if (!userProfile.preferences) {
              this.makeRegisterSuccess()
            }
            else this.makeOnboardingThreeIncomplete();
      
          }
          this.loginDone = true;
          this.loginDonegetApi = true;
          this.loginErr = false
        }


        else {
          // console.log("[login]", "login failed", response)
        }

      })
      // .then(() => userStore.pulluser())
      .catch(action((err) => {
        this.errors = err.response && err.response.body && err.response.body.errors;
        throw err;
      }))
      .finally(action(() => { this.inProgress = false; })
      );
  }

  @action OB2validation(data) {
    if (!data.interests) {
      // console.log("interests null")
      this.makeOnboardingOneIncomplete();
      return false;
    }
    if (!data.preferences) {
      // console.log("preferences null")
      this.makeOnboardingTwoIncomplete();
      return false;
    }
    return true;
  }
  @action socialLogin(body, id) {
    this.inProgress = true;
    this.errors = undefined;

    return agent.Auth.socialLogin(body)
      .then((response) => {
        // console.log("came in here")
        // console.log("resp = ", response)
        if (!response || response == {}) {
          commonStore.removeLoader();
          navigatorStore.openErrorModal("Something went wrong. Please try again.")
          return;
        }

        if (response.error == "True") {
          commonStore.removeLoader();
          navigatorStore.openErrorModal(response.error)
          // userStore.setErr(response)

          this.loginErr = true
          return;
        }
        if (response.error == "False" && response.data.token && response.data.token != "") {
          // console.log(response)
          commonStore.setToken(response.data.token,
            (response.data.user_profile[0].display_name) ? response.data.user_profile[0].display_name : response.data.user_profile[0].old_display_name,
            (!!response.data.user_profile[0].image) ? response.data.user_profile[0].image : (id && `http://graph.facebook.com/${id}/picture?type=large`) || "",
            response.data.user_profile[0].id,
            response.data.user_profile[0].preferred_currency,

          );
          userStore.setUser(response.data);
          var url = response.data.user_profile[0].share_url
          localStorage.setItem("username", url.substr(url.lastIndexOf("/") + 1))
          localStorage.setItem("primary_email", response.data.user_profile[0].primary_email)
          localStorage.setItem("country", response.data.user_profile[0].country)
          localStorage.setItem("full_name", response.data.user_profile[0].full_name)
          // if (!response.data.user_profile[0].interests) {
          //   // console.log("interests null")
          //   this.makeOnboardingOneIncomplete()
          // }
          // if (!response.data.user_profile[0].preferences) {
          //   // console.log("preferences null")
          //   this.makeOnboardingTwoIncomplete()
          // }
          if (!response.data.user_profile[0].display_name && !!response.data.user_profile[0].old_display_name) {
            let isValid = this.validateUsername(response.data.user_profile[0].old_display_name, true, response.data.user_profile[0], true)
            if (!isValid) {
              localStorage.setItem("just_registered", true);
              this.makeRegisterSuccess()
            }
            // if (this.onboardingThreeIncomplete) {
            //   localStorage.setItem("")
            //   this.makeRegisterSuccess()
            // }

            // this.loginDone = true;
            // this.loginDonegetApi = true;
            return;
          }
          if (!!response.data.user_profile[0].display_name) {
            let isValid = this.validateUsername(response.data.user_profile[0].display_name, false, response.data.user_profile[0], true)

            if (!isValid) {
              localStorage.setItem("just_registered", true)
              this.makeRegisterSuccess()
              return;
            }
            // if (!isValid ) {
            // this.makeRegisterSuccess();
            // this.loginDonegetApi = true;
            // this.loginDone = true;
            // }
          }
          if (!response.data.user_profile[0].full_name ||
            !response.data.user_profile[0].country ||
            //  !response.data.user_profile[0].full_name || 
            //  !response.data.user_profile[0].user.email || 
            //  !response.data.user_profile[0].display_name || 
            !response.data.user_profile[0].display_name ||
            response.data.user_profile[0].display_name.length >= 30 ||
            !response.data.user_profile[0].primary_email ||
            !response.data.user_profile[0].preferred_currency

          ) {

            // this.OB2validation(response.data.user_profile[0]);
            // console.log("profile null")
            // debugger;
            if (!response.data.user_profile[0].interests || !response.data.user_profile[0].preferences) {
              // this.makeRegisterSuccess()
              localStorage.setItem("just_registered", true)
              this.makeRegisterSuccess()
              return;

            } else {
              localStorage.setItem("incompleteOnboardingThree", true)
              this.makeRegisterSuccess()
              return;
              // this.makeOnboardinglThreeIncomplete();
            }
            // }
          }
          this.loginDonegetApi = true;
          // this.loginDone = true;
          // this.loginErr = false
        } else {
          // console.log("[login]", "login failed", response)
        }

      })
      // .then(() => userStore.pulluser())
      .catch(action((err) => {
        this.errors = err.response && err.response.body && err.response.body.errors;
        throw err;
      }))
      .finally(action(() => { this.inProgress = false; })
      );
  }

  @action resetLoginDone() {
    this.loginDone = false
  }
  @action resetLoginDoneGetApi() {
    this.loginDonegetApi = false;;
  }
  @action register(email, password) {
    return agent.Auth.register(email, password)
      .then((response) => {
        // console.log("came in here")
        // console.log("resp = ", response)
        if (!response || response == {}) {

          navigatorStore.openErrorModal("Something went wrong. Please try again.")
          return;
        }
        if (response.error == "True") {
          navigatorStore.openErrorModal(response.error)
          // userStore.setErr(response)
          this.loginErr = true
          return;
        }
        if (response.error == "False" && response.data.token && response.data.token != "") {
          // console.log(response)
          commonStore.setTokenAfterRegister(response.data.token,
            response.data.profile_id);
          userStore.setUser(response.data);
          // this.loginDone = true;
          this.loginDonegetApi = true;
          this.makeRegisterSuccess();
        }


        else {
          // console.log("[login]", "login failed", response)
        }

      })
      // .then(() => userStore.pulluser())
      .catch(action((err) => {
        this.errors = err.response && err.response.body && err.response.body.errors;
        throw err;
      }))
      .finally(action(() => { this.inProgress = false; })
      );
  }

  @action logout() {
    commonStore.setToken(undefined);
    commonStore.setTokenAfterRegister(undefined);
    localStorage.removeItem("username")
    localStorage.removeItem("registerDone")
    localStorage.removeItem("login_email")
    localStorage.removeItem("full_name")
    localStorage.removeItem("primary_email")
    localStorage.removeItem("country")
    userStore.forgetUser();
    // window.localStorage.clear();
    this.resetOnboardingStatuses("onboardingOneIncomplete")
    this.resetOnboardingStatuses("onboardingTwoIncomplete")
    this.resetOnboardingStatuses("onboardingThreeIncomplete")
    this.resetRegisterSuccess()
    return Promise.resolve();
  }
  @action forgotPW(body) {
    return agent.Auth.forgotPassword(body)
  }
  @action resetPW(body, auth_key) {
    return agent.Auth.resetPassword(body, auth_key)
  }
  @action changePasswordSecurity(body, auth_key) {
    // debugger;
    return agent.Auth.changePasswordSecurity(body, auth_key)
  }
  @action updatePW(body, auth_key) {
    // debugger;
    return agent.Auth.updatePW(body, auth_key)
  }

  @action resetOnboardingStatuses(identifier) {
    this[identifier] = false
    // console.log("[identifier]", identifier, this[identifier])
    this.updateComplete = true
    // this.onboardingTwoIncomplete = false,
    // this.onboardingThreeIncomplete = false
  }
  @action resetUpdateComplete() {
    this.updateComplete = false
    // console.log("identifier", this.updateComplete)
  }
}

export default new AuthStore();

function OB2validation(data) {
  if (!data.interests) {
    return 1;
  }
  if (!data.preferences) {
    return 2;
  }
  return 0;
}


// WEBPACK FOOTER //
// ./src/stores/authStore.js